import type { AnswerValue, Question } from "../types";

const norm = (s: string) => s.trim().toLowerCase();

/** Turn `our_recommendation` text into an answer for this question, or undefined when it does not map. */
export function acceptSuggestion(question: Question, text: string): AnswerValue | undefined {
  switch (question.type) {
    case "yes_no":
      return /^yes/i.test(text.trim());
    case "single_choice":
    case "multi_choice": {
      const opt = (question.options ?? []).find((o) => norm(o.label) === norm(text) || norm(o.value) === norm(text));
      if (!opt) return undefined;
      return question.type === "single_choice" ? opt.value : [opt.value];
    }
    case "short_text":
    case "long_text":
      return text;
    case "number": {
      const n = Number(text.trim());
      return text.trim() !== "" && Number.isFinite(n) ? n : undefined;
    }
    default:
      return undefined;
  }
}
